import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_751786943 from "../../../../../packages/component/src/components/affix/demo/demo1.js?loadDemo";
import legacyImportDemo_1152809820 from "../../../../../packages/component/src/components/affix/demo/demo2.js?loadDemo";
import legacyImportDemo_2458962045 from "../../../../../packages/component/src/components/affix/demo/demo3.js?loadDemo";
import legacyImportDemo_50626074 from "../../../../../packages/component/src/components/affix/demo/demo4.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_751786943,
  legacyImportDemo_1152809820,
  legacyImportDemo_2458962045,
  legacyImportDemo_50626074,
  React
};